import { NoticeSeverity } from '@navio/nsdk';

/** Banner tone per severity. Shared by the customer and partner banners. */
export const NOTICE_SEVERITY_BANNER_VARIANT = {
  [NoticeSeverity.INFO]: 'info',
  [NoticeSeverity.WARNING]: 'warning',
  [NoticeSeverity.CRITICAL]: 'error'
} as const;
